/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowBookClubTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowBookClub,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Read Together!",
    "Book Lovers Unite!",
    "Join the Book Discussion!",
  ],
  title: "Book Club",
  description: "Plan the next book club meeting and book selection.",
  longDescription:
    "Organize your next book club meeting. Choose a date, select a book to read, and decide on snacks to enjoy while discussing!",
  emoji: "📚",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Calendar,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Book Club",
          emoji: "📚",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we meet?",
          emoji: "📅",
          completeAction: {
            question: "Decide on a book?",
            description: "What book should we read for the next meeting?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What book should we read?",
                emoji: "📖",
                completeAction: {
                  question: "Decide on snacks?",
                  description: "What snacks should we have for the meeting?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What snacks should we get?",
                      emoji: "🍪",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Happy Reading!",
    outroDescription:
      "Your book club plans are set! Enjoy the reading and discussion!",
  },
};
